import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=29ca66ed&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=29ca66ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ca66ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ca66ed')) {
      api.createRecord('29ca66ed', component.options)
    } else {
      api.reload('29ca66ed', component.options)
    }
    module.hot.accept("./dashboard.vue?vue&type=template&id=29ca66ed&scoped=true&", function () {
      api.rerender('29ca66ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/dashboard.vue"
export default component.exports